import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicSizeIcon from "../DynamicSizeIcon";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeFrame from "../DynamicSizeFrame";
interface NetworkOptionPropsType extends GeneralPropsType {
  icon?: string;
  name?: string;
  isSelected?: boolean;
  onClick?: (data?: any) => any;
}
function NetworkOption({
  icon,
  name,
  isSelected,
  className,
  onClick
}: NetworkOptionPropsType) {
  return <div onClick={onClick} className={clsx("border rounded-2xl flex items-center gap-2 p-3 overflow-hidden duration-300 select-none", styles.container, className, {
    "border-secondary bg-secondary/[0.16] relative after:content-[''] after:z-50 after:absolute after:rotate-[45deg] after:translate-x-[16px] after:-translate-y-[8px] after:block after:w-9 after:aspect-[2] after:bg-secondary after:right-0 after:top-0": isSelected,
    "bg-white/[0.16] border-description": !isSelected
  })} data-sentry-component="NetworkOption" data-sentry-source-file="index.tsx">
            <DynamicSizeFrame width={24} style={{
      backgroundImage: `url(${icon})`
    }} className="rounded-full bg-center bg-cover bg-no-repeat" data-sentry-element="DynamicSizeFrame" data-sentry-source-file="index.tsx" />

            <DynamicFontSize fontSize={14} className="text-white leading-[160%] font-medium flex-1" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                {name}
            </DynamicFontSize>
        </div>;
}
export default NetworkOption;